<script lang="ts">
    import { TemplateFieldComponentLayout } from '@allibee/components/common';
    import type { NodeViewProps } from '@tiptap/core';
    import { NodeViewWrapper } from 'svelte-tiptap';
    import { twMerge } from 'tailwind-merge';

    export let node: NodeViewProps['node'];
    export let selected: NodeViewProps['selected'];

    // table(td)요소 내부에서 영역이 강제로 좁아지는 문제 해결
    const textIndent = 'text-indent: 0 !important;';
</script>

<NodeViewWrapper as="span">
    <span class="bhsn-reference">
        <span />
        <TemplateFieldComponentLayout
            class={twMerge('cursor-move', $$props.class)}
            fieldType={node.attrs['data-type'] || 'text'}
            {selected}
            focused={node.attrs['focused-input']}
            data-drag-handle
            contenteditable="false"
        >
            <span data-node-view-content style={textIndent}>
                {#if !node.content.size}
                    {node.attrs['data-name']}
                {/if}
            </span>
        </TemplateFieldComponentLayout>
        <span />
    </span>
</NodeViewWrapper>
